import React from "react";
import { TabContent, TabPane } from "reactstrap";
import ConfigurationPane from "../../views/Component/ConfigurationPane";

function DefaultAside() {
  return (
    <div id="entity">
      <TabContent>
        <TabPane>
          <ConfigurationPane />
        </TabPane>
      </TabContent>
    </div>
  );
}

export default DefaultAside;
